<template>

  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">

    <modal :show.sync="videoModal.active" body-classes="p-0" modal-classes="modal-lg">
      <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
        <h2>{{videoModal.title}}</h2>
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" :src="videoModal.url" allowfullscreen></iframe>
        </div>
      </card>
    </modal>

    <modal v-on:close="modalClosed()" :show.sync="frameModal.active" body-classes="p-0" modal-classes="modal-lg">
      <card type="secondary" header-classes="bg-white pb-5" body-classes="px-lg-5 py-lg-5" class="border-0 mb-0">
        <h2>{{frameModal.title}}</h2>
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" :src="frameModal.url" allowfullscreen></iframe>
        </div>
      </card>
    </modal>

    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
      :background-color="sidebarBackground"
      :short-title="$t('sidebar.shortTitle')"
      :title="$t('sidebar.title')"
    >
      <template slot-scope="props" slot="links">

        <sidebar-item v-for="item in sidebarMenu" :link="item">

          <!-- Item with sub-items (and sub-items with links  -->
          <sidebar-item v-for="subItem in item.items" :link="subItem">
            <li class="modalLink" v-for="link in subItem.links">
              <a @click="frameModalActivate(link)"  class="">
                <span class="sidebar-mini-icon">L1-II</span>
                <span class="sidebar-normal">{{ link.title }}</span>
              </a>
            </li>
            <sidebar-item v-if="subItem.links" :link="{}"></sidebar-item>
          </sidebar-item>

          <!-- Item with links -->
          <li class="modalLink" v-for="link in item.links">
            <a @click="frameModalActivate(link)"  class="">
              <span class="sidebar-mini-icon">L1-II</span>
              <span class="sidebar-normal">{{ link.title }}</span>
            </a>
          </li>
          <sidebar-item v-if="item.links" :link="{}"></sidebar-item>

        </sidebar-item>

      </template>
    </side-bar>
    <!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->

    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>

      <div
        :class="{ content: !$route.meta.hideContent }"
        @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import {Modal} from 'src/components';
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import SidebarShare from './SidebarSharePlugin';
function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { SlideYDownTransition, ZoomCenterTransition } from 'vue2-transitions';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    DashboardContent,
    SlideYDownTransition,
    ZoomCenterTransition,
    SidebarShare,
    Modal
  },
  data() {
    return {
      sidebarBackground: 'primary', //vue|blue|orange|green|red|primar
      videoModal: {
        active: false,
        title:'',
        url:''
      },
      frameModal: {
        active: false,
        title:'',
        url:''
      },
      sidebarMenu: [
        {
          name: 'Dashboard',
          icon: 'tim-icons icon-chart-bar-32',
          path: '/',
        },
        {
          name: 'Education Center',
          icon: 'tim-icons icon-bulb-63',
          items: [
            {
              name: 'Chapter 1',
              links: [
                {title: 'Important Introduction',url: '/members-education-center/important-introduction/'},
                {title: 'Specific XABCD Points', url: '/members-education-center/specific-xabcd-points/'},
                {title: 'Classifications of Patterns', url: '/members-education-center/classifications-of-patterns/'}
              ]
            },
            {
              name: 'Chapter 2',
              links: [
                {title: 'Manually Finding Patterns', url: '/members-education-center/manually-finding-patterns/'},
                {title: 'Auto Finding Patterns', url: '/members-education-center/auto-finding-patterns/'},
                {title: 'Web Based Scanning', url: '/members-education-center/web-based-scanning/'},
                {title: 'Manual vs Automatic Scanning', url: '/members-education-center/manual-vs-automatic-scanning/'},
              ]
            },
            {
              name: 'Chapter 3',
              links: [
                {title: 'Summary of Patterns', url: '/members-education-center/summary-of-patterns/'},
                {title: 'Layout of Charts', url: '/members-education-center/layout-of-charts/'},
                {title: 'Internal Time Measurements', url: '/members-education-center/internal-time-measurements/'},
                {title: 'External Time Measurements', url: '/members-education-center/external-time-measurements/'},
                {title: 'Retracement Time Patterns Specifics', url: '/members-education-center/retracement-time-patterns-specifics/'},
                {title: 'Extension Time Pattern Specifics', url: '/members-education-center/extension-time-pattern-specifics/'},
                {title: 'Risk Vs Reward', url: '/members-education-center/risk-vs-reward/'},
              ]
            },
            {
              name: 'Chapter 4',
              links: [
                {title: 'The Basics of Pattern Trading', url: '/members-education-center/the-basics-of-pattern-trading/'},
                {title: 'Places to Enter The Pattern', url: '/members-education-center/places-to-enter-the-pattern/'},
                {title: 'What Is The Attractor?', url: '/members-education-center/what-is-the-attractor/'},
                {title: 'Bar Count Inside A Pattern', url: '/members-education-center/bar-count-inside-a-pattern/'},
                {title: 'Where Can Stops Go?', url: '/members-education-center/where-can-stops-go/'},
                {title: 'Moving Stops to Break Even', url: '/members-education-center/moving-stops-to-break-even/'},
                {title: 'Places to Potentially Target', url: '/members-education-center/places-to-potentially-target/'},
              ]
            },
            {
              name: 'Chapter 5',
              links: [
                {title: 'Weighting Trades with Sonar', url: '/members-education-center/weighting-trades-with-sonar/'},
                {title: 'Examples of Sonar', url: '/members-education-center/examples-of-sonar/'},
                {title: 'Weighting Trades using Hurst', url: '/members-education-center/weighting-trades-using-hurst/'},
                {title: 'Examples of Hurst', url: '/members-education-center/examples-of-hurst/'},
                {title: 'Using Hurst and Sonar Together', url: 'https://www.xabcdtrading.com/members-education-center/using-hurst-and-sonar-together/'},


              ]
            },
            {
              name: 'Chapter 6',
              links: [
                {title: 'Narrowing Down Your Entry Point', url: '/members-education-center/narrowing-down-your-entry-point/'},
                {title: 'Combining Patterns with Other Strategies', url: '/members-education-center/combining-patterns-with-other-strategies/'},
                {title: 'Scaling Into Trades', url: '/members-education-center/scaling-into-trades/'},
                {title: 'Nested Patterns', url: '/members-education-center/nested-patterns/'},



              ]
            },
          ],
        },
        {
          name: 'My Indicators',
          icon: 'tim-icons icon-cloud-download-93',
          links: [
            {title: 'Pattern Indicators', url: '/members-education-center/members-indicators/'},
            {title: 'Licenses', url: '/members-education-center/members-licenses/'},
          ]
        },
        {
          name: 'My Live Streams',
          icon: 'tim-icons icon-video-66',
          links: [
            {title: 'Recordings', url: '/members-education-center/webinar-recordings/'},
            {title: 'Stream Information', url: '/members-education-center/webinar-information/'},
          ]
        },
        {
          name: 'Help',
          icon: 'tim-icons icon-sound-wave',
          links: [
            {title: 'Support', url: '/members-education-center/members-support/'},
            {title: 'FAQ', url: '/members-education-center/faq/'},
          ]
        },
      ],
    };
  },
  methods: {
    modalClosed(){
      this.frameModal.url = '';
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    videoModalActivate(video){
      console.log(video);
      this.videoModal.active = true;
      this.videoModal.title = video.title;
      this.videoModal.url = video.url;
    },
    frameModalActivate(frame){

      this.frameModal.active = true;
      this.frameModal.title = frame.title;
      this.frameModal.url = frame.url;
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  },
  mounted() {
    this.initScrollbar();

  }
};
</script>
<style lang="scss">

.sidebar-mini-icon{ height: 1px !important; overflow: hidden;  opacity: 100; display: block; }

.sidebar .nav li.active > a:not([data-toggle="collapse"]):before{display: none !important;}


$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
